import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import ExpandablePanel from '../ExpandablePanel';
import DetailsInfoRow from '../DetailsInfoRow';

import theme from './ServiceInfoRow.scss';

const propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  providingUnit: PropTypes.object,
  isDisabled: PropTypes.bool,
};

const defaultProps = {
  name: undefined,
  description: undefined,
  providingUnit: undefined,
  isDisabled: PropTypes.bool,
};

const ServiceInfoRow = ({
  intl,
  name,
  description,
  providingUnit,
  isDisabled,
  logo,
}) => (
  <Choose>
    <When condition={ providingUnit || description }>
      <ExpandablePanel
        expandedAriaLabel={ intl.formatMessage({ id: 'Appointment.DetailsTab.CollapseServiceButton.TitleAttribute', defaultMessage: '** Collapse service details' }) }
        collapsedAriaLabel={ intl.formatMessage({ id: 'Appointment.DetailsTab.ExpandServiceButton.TitleAttribute', defaultMessage: '** Expand service details' }) }
        className={ theme.labelContainer }
        labelComponent={ () => (
          <div className={ theme.expandedPanel }>
            <DetailsInfoRow
              iconName="service"
              isExpandable
              isDisabled={ isDisabled }
              title={
                <FormattedMessage
                  id="Appointment.View.Details.Service.Title"
                  defaultMessage="** Service"
                />
              }
              avatar={ logo === '' ? undefined : logo }
              description={ name }
            />
          </div>
        ) }
      >
        <div className={ theme.contentContainer }>
          <If condition={ providingUnit }>
            <DetailsInfoRow
              insidePanel
              isWrapped
              iconName="health-representative"
              title={
                <FormattedMessage
                  id="Appointment.View.Details.ProvidingUnit.Title"
                  defaultMessage="** Providing unit"
                />
              }
              avatar={ providingUnit.logo === '' ? undefined : providingUnit.logo }
              description={ providingUnit.name }
            />
          </If>

          <If condition={ description }>
            <DetailsInfoRow
              insidePanel
              iconName="circle-info"
              isWrapped
              title={
                <FormattedMessage
                  id="Appointment.View.Details.ServiceDescription.Title"
                  defaultMessage="** Description"
                />
              }
              descriptionSize="small"
              description={ description }
            />
          </If>
        </div>
      </ExpandablePanel>
    </When>
    <Otherwise>
      <DetailsInfoRow
        iconName="service"
        isDisabled={ isDisabled }
        withBorder
        title={
          <FormattedMessage
            id="Appointment.View.Details.Service.Title"
            defaultMessage="** Service"
          />
        }
        description={ name }
        avatar={ logo === '' ? undefined : logo }
      />
    </Otherwise>
  </Choose>
);

ServiceInfoRow.propTypes = propTypes;
ServiceInfoRow.defaultProps = defaultProps;

export default injectIntl(ServiceInfoRow);
